import React from 'react';

import { ApButtonLink, ApChip } from '@alixpartners/ui-components';
import { FilterDropdown } from 'components/FilterDropdown';
import { PERIOD_KEY } from '../../utils';
import sortBy from 'lodash/sortBy';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import { getApiParamsFromFilterModel } from '../utils';
import { getBudgetFilters } from 'utils/apiRequests';
import {
	Wrapper,
	HeaderRow,
	HeaderLabel,
	ChipWrapper,
	DropdownLabel,
	DropdownWrapper,
	FilterWrapper,
} from './FiltersSection.styles';

export class FiltersSection extends React.Component {
	state = {
		availableFilters: null,
	};

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps) {
		const { filtersList } = this.props;

		if (!isEqual(filtersList, prevProps.filtersList)) {
			this.fetchData();
		}
	}

	fetchData = () => {
		const { filterModel } = this.props;

		return getBudgetFilters(getApiParamsFromFilterModel(filterModel)).then(
			availableFilters => {
				this.setState({ availableFilters }, this.updateSelectedValues);
			}
		);
	};

	updateSelectedValues = () => {
		const { filterModel, onFilterModelChange } = this.props;
		const { availableFilters } = this.state;

		if (
			!filterModel.filters ||
			isEmpty(filterModel.filters) ||
			!availableFilters
		) {
			return;
		}

		const updatedFilters = Object.keys(filterModel.filters).reduce(
			(acc, dimension) => {
				const currentFilter = availableFilters.find(
					filter => filter.dimension === dimension
				);
				const availableValues = currentFilter ? currentFilter.values : [];
				const updatedValues = filterModel.filters[dimension].filter(value =>
					availableValues.includes(value)
				);

				return { ...acc, [dimension]: updatedValues };
			},
			{}
		);

		onFilterModelChange({ ...filterModel, filters: updatedFilters });
	};

	getOptions = (dimension, allValues) => {
		const { availableFilters } = this.state;
		const currentFilter =
			availableFilters &&
			availableFilters.find(filter => filter.dimension === dimension);
		const availableValues = currentFilter ? currentFilter.values : [];

		const options = sortBy(
			allValues.map(value => ({
				value,
				label: value,
				disabled: !availableValues || !availableValues.includes(value),
			})),
			'disabled'
		);

		return options;
	};

	changePeriod = values => {
		const { filterModel, onFilterModelChange } = this.props;

		onFilterModelChange({ ...filterModel, monthNumbers: values.sort() });
	};

	changeFilter = dimension => values => {
		const { filterModel, onFilterModelChange } = this.props;

		onFilterModelChange(
			{
				...filterModel,
				filters: {
					...(filterModel.filters ? filterModel.filters : {}),
					[dimension]: values.sort(),
				},
			},
			this.fetchData
		);
	};

	removePrimaryFilter = () => {
		const { filterModel, onFilterModelChange } = this.props;

		onFilterModelChange({ ...filterModel, primaryFilter: null });
	};

	clearAll = () => {
		const { onFilterModelChange, filterModel } = this.props;
		const isModelEmpty = isEmpty(filterModel);

		onFilterModelChange({}, () => {
			if (!isModelEmpty) {
				this.fetchData();
			}
		});
	};

	render() {
		const { filterModel, filtersList, isFiltersLoading } = this.props;

		return (
			<Wrapper>
				<HeaderRow>
					<HeaderLabel>Select data to include in the report</HeaderLabel>
					<ApButtonLink onClick={this.clearAll}>Clear all</ApButtonLink>
				</HeaderRow>
				{filterModel.primaryFilter && (
					<ChipWrapper>
						<ApChip
							onClick={this.removePrimaryFilter}
							iconName="outline_cancel"
						>
							{filterModel.primaryFilter}
						</ApChip>
					</ChipWrapper>
				)}

				{filtersList.map(({ label, values, dimension }) => (
					<FilterWrapper key={dimension}>
						<DropdownLabel>{label}</DropdownLabel>
						<DropdownWrapper>
							<FilterDropdown
								options={this.getOptions(dimension, values)}
								isLoading={isFiltersLoading}
								selected={
									dimension === PERIOD_KEY
										? filterModel.monthNumbers
										: filterModel.filters
											? filterModel.filters[dimension]
											: null
								}
								onChange={
									dimension === PERIOD_KEY
										? this.changePeriod
										: this.changeFilter(dimension)
								}
							/>
						</DropdownWrapper>
					</FilterWrapper>
				))}
			</Wrapper>
		);
	}
}
